<template>
  <div class="workshop-approval-panel" :class="{ 'pa-4': !compact }">
    <!-- Phone: one row with the action and a toggle for the blocking lists. -->
    <div v-if="compact" class="d-flex align-center ga-2">
      <v-btn
        v-if="panel.manager"
        color="green"
        variant="flat"
        class="flex-grow-1 workshop-approval-action"
        :disabled="!panel.canApprove || approving"
        :loading="approving"
        @click="$emit('approve')"
      >
        {{ $t("workshop.checklist.approve") }}
      </v-btn>
      <span v-else class="flex-grow-1 text-body-2 text-medium-emphasis">
        {{ $t("workshop.checklist.waiting_approval") }}
      </span>
      <v-btn
        v-if="blockingCount"
        variant="text"
        size="small"
        class="workshop-approval-action"
        :append-icon="open ? 'mdi-chevron-down' : 'mdi-chevron-up'"
        :aria-expanded="open ? 'true' : 'false'"
        @click="open = !open"
      >
        {{ $t("workshop.checklist.blocking_count", { count: blockingCount }) }}
      </v-btn>
    </div>

    <div v-if="!compact || open" :class="{ 'mt-2': compact }">
      <div v-if="panel.missing.length" class="mb-2">
        <div class="text-body-2 font-weight-medium">
          {{
            $t("workshop.checklist.missing_tasks", {
              count: panel.missing.length,
            })
          }}
        </div>
        <div class="d-flex flex-wrap ga-1 mt-1">
          <v-chip
            v-for="code in panel.missing"
            :key="code"
            size="small"
            variant="outlined"
            @click="$emit('select', code)"
          >
            {{ $t(taskKey(code)) }}
          </v-chip>
        </div>
      </div>
      <div v-if="panel.exceptions.length" class="mb-2">
        <div class="text-body-2 font-weight-medium">
          {{
            $t("workshop.checklist.pending_exceptions", {
              count: panel.exceptions.length,
            })
          }}
        </div>
        <div class="d-flex flex-wrap ga-1 mt-1">
          <v-chip
            v-for="code in panel.exceptions"
            :key="code"
            size="small"
            variant="tonal"
            color="amber-darken-2"
            @click="$emit('select', code)"
          >
            {{ $t(taskKey(code)) }}
          </v-chip>
        </div>
      </div>
      <template v-if="!compact">
        <div v-if="panel.manager" class="d-flex flex-wrap align-center ga-3">
          <v-btn
            color="green"
            variant="flat"
            :disabled="!panel.canApprove || approving"
            :loading="approving"
            @click="$emit('approve')"
          >
            {{ $t("workshop.checklist.approve") }}
          </v-btn>
          <span
            v-if="!panel.canApprove"
            class="text-caption text-medium-emphasis"
          >
            {{ $t("workshop.checklist.approve_hint") }}
          </span>
        </div>
        <div v-else class="text-body-2 text-medium-emphasis">
          {{ $t("workshop.checklist.waiting_approval") }}
        </div>
      </template>
      <div
        v-else-if="panel.manager && !panel.canApprove"
        class="text-caption text-medium-emphasis"
      >
        {{ $t("workshop.checklist.approve_hint") }}
      </div>
    </div>
  </div>
</template>

<script>
import { approvalPanel, taskKey } from "@/components/Workshop/workshopView.mjs";

// The approval panel of an unapproved checklist (Stage 3a plan §D2, slice 8): the missing
// mandatory tasks and the exceptions to accept (each selects its task), "Approva bonifica" for a
// Manager/Admin (enabled by the view's canApprove; the API checks again) and "In attesa di
// approvazione" for a User. Desktop shows it under the task; the phone (compact) shows one row
// above the bottom bar, with the lists behind a toggle.
export default {
  name: "WorkshopApprovalPanel",
  props: {
    // The checklist view
    view: { type: Object, required: true },
    compact: { type: Boolean, default: false },
    approving: { type: Boolean, default: false },
  },
  emits: ["select", "approve"],
  data: () => ({
    open: false,
  }),
  computed: {
    panel() {
      return approvalPanel(this.view);
    },
    blockingCount() {
      return this.panel.missing.length + this.panel.exceptions.length;
    },
  },
  methods: {
    taskKey,
  },
};
</script>

<style scoped>
.workshop-approval-action {
  min-height: 48px;
}
</style>
